import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Snackbar,
  Alert,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { makeStyles } from "@mui/styles";
import axios from "axios"; // Import Axios
import { useDispatch, useSelector } from "react-redux";
import { getOptixDataSuccess } from "../../store/comprehensiveImageViewer/imageViewerSlice";
import AuditBasedQuestion from "./AuditBasedQuestion";

const useStyles = makeStyles((theme) => ({
  accordionContent: {
    display: "flex",
    gap: "1rem",
    alignItems: "center",
    justifyContent: "space-between",
  },
  accordionSummary: {
    flexDirection: "row", // Revert to the default row direction
    paddingLeft: "0px", // Remove left padding
  },
  headingContainer: {
    display: "flex",
    justifyContent: "space-between",
    gap: "1rem",
    width: "100%",
  },
  processedText: {
    marginLeft: "auto",
  },
  expandIcon: {
    marginRight: "auto",
  },
}));

function SelectedSessionAudit({ auditIDs, time, count }) {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const [auditData, setAuditData] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const dispatch = useDispatch();
  console.log(auditIDs)

  useEffect(() => {
    const fetchAuditData = async () => {
      await axios
        .post("/get_context/get_optix_data", {
          //auditID:"0LTZCBHE2VJ9FOT"
          auditID: auditIDs[0],
        })
        .then((response) => {
          if (response.status === 200) {
            dispatch(getOptixDataSuccess(response.data));
            setAuditData(response.data);
          } else {
            // console.error(`HTTP Error: ${response.status}`);
            setOpenSnackbar(true);
            setTimeout(() => {
              setOpenSnackbar(false);
            }, 5000);
          }
        })
        .catch((error) => {
          // console.error("Error:", error);
          setOpenSnackbar(true);
          setTimeout(() => {
            setOpenSnackbar(false);
          }, 5000);
        });

      //   const auditItem = response.data;
      //  // console.log(auditItem);
      //    dispatch(getOptixDataSuccess(auditItem));
      //   setAuditData(auditItem);
      // } catch (error) {
      //   console.error(`Error fetching data for audit ID`, error);
      // }
    };
    fetchAuditData();
    // auditIDs.forEach((auditID) => {
    //   fetchAuditData(auditID);
    // });
  }, []);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  console.log(auditData);
  const { optixData } = useSelector((state) => state.imageViewerStore);
  console.log(optixData);
  return (
    <>
    {optixData.length ===0 && <Box><Typography style={{fontSize:"11px",marginTop:"0.5rem"}}>No Data</Typography></Box>}
    <div style={{ width: "118%", marginTop: "0.4rem" }}>
      <AuditBasedQuestion time={time} count={count} />
    </div>
    <Snackbar
        open={openSnackbar}
        autoHideDuration={5000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert severity="error" onClose={() => setOpenSnackbar(false)}>
          Resource not found
        </Alert>
      </Snackbar>
    </>
  );
}

export default SelectedSessionAudit;
